import { ENDPOINTS } from '../constants/endpoints'
import type { AxiosResponse } from 'axios'
import type {
  Donation,
  DonationCreateInput,
  DonationUpdateInput,
} from '../types/donation'
import axiosInstance from '@/integrations/axios/axios-instance'

export const donationsApi = {
  getDonations: (): Promise<AxiosResponse<{ donations: Array<Donation> }>> => {
    const endpoint = ENDPOINTS.GET_DONATIONS
    return axiosInstance.get(endpoint)
  },
  getDonation: (
    donationId: string,
  ): Promise<AxiosResponse<{ donation: Donation }>> => {
    const endpoint = `${ENDPOINTS.GET_DONATION}/${donationId}`
    return axiosInstance.get(endpoint)
  },
  createDonation: (
    donation: DonationCreateInput,
  ): Promise<AxiosResponse<{ message: string; donation: Donation }>> => {
    const endpoint = ENDPOINTS.CREATE_DONATION
    return axiosInstance.post(endpoint, donation)
  },
  updateDonation: (
    donation: DonationUpdateInput,
  ): Promise<AxiosResponse<{ message: string; donation: Donation }>> => {
    const endpoint = `${ENDPOINTS.UPDATE_DONATION}/${donation._id}`
    return axiosInstance.put(endpoint, donation)
  },
  verifyDonation: (
    donation: DonationUpdateInput,
  ): Promise<AxiosResponse<{ message: string; donation: Donation }>> => {
    const endpoint = `${ENDPOINTS.VERIFY_DONATION}/${donation._id}`
    return axiosInstance.put(endpoint, donation)
  },
  deleteDonation: (
    donationId: string,
  ): Promise<AxiosResponse<{ message: string; id: string }>> => {
    const endpoint = `${ENDPOINTS.DELETE_DONATION}/${donationId}`
    return axiosInstance.delete(endpoint)
  },
  uploadDonationDepositReceipt: (
    donationId: string,
    depositDate: string,
    depositReceipt: File,
    notes?: string,
  ): Promise<AxiosResponse<{ message: string; donation: Donation }>> => {
    const endpoint = ENDPOINTS.UPLOAD_DEPOSIT_RECEIPT
    const formData = new FormData()
    formData.append('donationId', donationId)
    formData.append('depositDate', depositDate)
    formData.append('depositReceipt', depositReceipt)
    if (notes) {
      formData.append('notes', notes)
    }
    return axiosInstance.post(endpoint, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  getCashDepositReceipt: (
    donationId: string,
  ): Promise<
    AxiosResponse<{ success: boolean; downloadUrl: string; fileName: string }>
  > => {
    const endpoint = `${ENDPOINTS.GET_CASH_DEPOSIT_RECEIPT}/${donationId}`
    return axiosInstance.get(endpoint)
  },
  sendRegistrationRequest: (
    donationId: string,
  ): Promise<AxiosResponse<{ success: boolean; sentTo: string; donation: Donation }>> => {
    const endpoint = `${ENDPOINTS.SEND_REGISTRATION_REQUEST}/${donationId}`
    return axiosInstance.post(endpoint)
  },
}
